import { render, staticRenderFns } from "./GoldCoast.vue?vue&type=template&id=09c79190&scoped=true"
import script from "./GoldCoast.vue?vue&type=script&lang=js"
export * from "./GoldCoast.vue?vue&type=script&lang=js"
import style0 from "./GoldCoast.vue?vue&type=style&index=0&id=09c79190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c79190",
  null
  
)

export default component.exports